// Proxy holder picker on the grant form (§4).
//
// Progressive enhancement over a real <select name="proxy_vote[proxy_holder_id]">
// that is rendered with every active proxy holder on the order — same shape as
// nominee_unit_select.js. With this pack disabled you get that plain dropdown
// and the form still submits.
//
// The narrowing is done server-side, through proxy_holder_options, rather than
// by filtering the rendered options: an association can have as many proxy
// holders as it has members, and the search has to match the holder's unit
// address as well as their name.
const DEBOUNCE_MS = 200;

function initProxyHolderSelect(root) {
  const search = root.querySelector('[data-proxy-holder-search]');
  const select = root.querySelector('[data-proxy-holder-select]');

  if (!search || !select) return;
  if (search.dataset.proxyHolderReady === 'true') return;
  search.dataset.proxyHolderReady = 'true';

  const url = search.dataset.optionsUrl;
  if (!url) return;

  // Keep the server-rendered list so an empty search box restores it without a
  // round trip, and so a failed request leaves the form usable.
  const original = Array.from(select.options).map((option) => ({
    value: option.value,
    label: option.text,
  }));

  const repaint = (options, keep) => {
    select.innerHTML = '';
    options.forEach(({ value, label }) => {
      const option = document.createElement('option');
      option.value = value;
      option.text = label;
      select.appendChild(option);
    });
    if (keep && options.some((option) => option.value === keep)) select.value = keep;
  };

  let timer = null;

  search.addEventListener('input', () => {
    window.clearTimeout(timer);

    timer = window.setTimeout(() => {
      const term = search.value.trim();
      const chosen = select.value;

      if (term === '') {
        repaint(original, chosen);
        return;
      }

      fetch(`${url}?q=${encodeURIComponent(term)}`, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      })
        .then((response) => (response.ok ? response.json() : Promise.reject(response)))
        .then((holders) => {
          const blank = original.find((option) => option.value === '');
          const found = holders.map((holder) => ({ value: String(holder.id), label: holder.label }));
          repaint(blank ? [blank, ...found] : found, chosen);
        })
        .catch(() => {
          // Leave whatever is on screen. A dropdown that still lists everybody
          // is better than one that has emptied itself.
        });
    }, DEBOUNCE_MS);
  });
}

document.addEventListener('turbo:load', () => initProxyHolderSelect(document));
document.addEventListener('DOMContentLoaded', () => initProxyHolderSelect(document));
